import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl-next';
import { styled } from '@compiled/react';

import SectionMessage from '@atlaskit/section-message/section-message';

const i18n = defineMessages({
	refresh: {
		id: 'comment.refresh-link',
		defaultMessage: 'refresh',
		description: 'Reload browser',
	},
	Refresh: {
		id: 'comment.refresh-link.capitalized',
		defaultMessage: 'Refresh',
		description: 'Reload browser (capitalized)',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SaveCommentWarningContainer = styled.div({
	marginLeft: '51px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledLink = styled.a({
	cursor: 'pointer',
});

const reloadBrowser = () => {
	window.location.reload();
};

const RefreshLink = ({ message }) => (
	<StyledLink onClick={reloadBrowser}>
		<FormattedMessage {...message}>{(text) => text}</FormattedMessage>
	</StyledLink>
);

export const CommentSaveWarning = ({ errorMessage }) => (
	<SaveCommentWarningContainer data-cy="save-comment-warning">
		<SectionMessage appearance="warning">
			<FormattedMessage
				{...errorMessage}
				tagName="p"
				values={{
					refresh: <RefreshLink message={i18n.refresh} />,
					Refresh: <RefreshLink message={i18n.Refresh} />,
				}}
			/>
		</SectionMessage>
	</SaveCommentWarningContainer>
);

CommentSaveWarning.propTypes = {
	errorMessage: PropTypes.object.isRequired,
};

RefreshLink.propTypes = {
	message: PropTypes.object.isRequired,
};
